// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bg_pk {background-color: #ffc6c6 !important; color: #909090 !important;}\n.actual_alert {height: auto !important; min-height: 350px;}\n.tooltip_wrap {min-width:300px; right:0; top:24px; display:none; text-align: left;}\n.tooltip_wrap .cont {word-break: keep-all;}\n.margin-left {\n  margin-left: 80px !important;\n}\n", ""]);
// Exports
module.exports = exports;
